// TODO: Remove this
export const _deprecated_serviceEntryMap = {
  // [getServiceEntry('log', 'controller', 'logController')]: require('../services/log/entry/controller/logController'),
  // [getServiceEntry('log', 'webSocket', 'onWebsocketEvent')]: require('../services/log/entry/webSocket/onWebsocketEvent'),
  // [getServiceEntry('log', 'controller', 'loginController')]: require('../services/log/entry/controller/loginController'),
  // [getServiceEntry('log', 'storageDrive', 'onCreate')]: require('../services/log/entry/storageDrive/onCreate'),
  // [getServiceEntry('migration', 'deployEvent', 'onDeploy')]: require('../services/migration/entry/deployEvent/onDeploy'),
  // [getServiceEntry('seed', 'deployEvent', 'onDeploy')]: require('../services/seed/entry/deployEvent/onDeploy'),
  // [getServiceEntry('cloudflare', 'cloudflare', 'onDeploy')]: require('../services/cloudflare/entry/cloudflare/onDeploy'),
};
